// src/theme/ThemeContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

const ThemeContext = createContext();

export const CustomThemeProvider = ({ children }) => {
  const [mode, setMode] = useState('light');

  const toggleTheme = () => {
    setMode(prev => (prev === 'light' ? 'dark' : 'light'));
  };

  const theme = useMemo(() => {
    return createTheme({
      palette: {
        mode,
        ...(mode === 'light'
          ? {
              primary: { main: '#FF9C00' },         // Orange
              secondary: { main: '#802000' },       // Deep red
              background: {
                default: '#f4f4f4',
                paper: '#ffffff',
              },
              text: {
                primary: '#1a1a1a',
                secondary: '#555555',
              },
            }
          : {
              primary: { main: '#FF9C00' },
              secondary: { main: '#FFD700' },
              background: {
                default: '#121212',
                paper: '#1E1E1E',
              },
              text: {
                primary: '#ffffff',
                secondary: '#cccccc',
              },
            }),
      },
      components: {
        MuiAppBar: {
          styleOverrides: {
            root: {
              backgroundColor: mode === 'light' ? '#FF9C00' : '#1E1E1E',
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: 'none',
              fontWeight: 'bold',
            },
          },
        },
      },
    });
  }, [mode]);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useCustomTheme = () => useContext(ThemeContext);
